import APICom from "./helpers/APICom";

  const DateTimeUtils = {

    /*
    * This will return the data alway in this format "YYYY-MM-DD"
    * Don't use ISO date because it is using UTC time, It might be different from local time
    * Exmaple: if current date is 2025-02-14, then ISO might return you 2025-02-13
    * 
    * new Date()	Local Time
    * 
    * new Date().toISOString()	UTC Time
    * 
    * new Date().toLocaleString()	Local Time (formatted)
    * 
    * 
    * @returns currentDate without ISO UTC
    */
      getCurrentDate: () => {
        let date = new Date();
        return date.getFullYear() + (date.getMonth() < 9 ? "-0" : "-") + (date.getMonth() + 1) + "-" + (date.getDate() < 10 ? "0" : "") + date.getDate();
      },

    /*
    * This will return the data alway in this format "HH:MM:SS"
    * Don't use ISO date because it is using UTC time, It might be different from local time
    * 
    * new Date()	Local Time
    * 
    * new Date().toISOString()	UTC Time
    * 
    * new Date().toLocaleString()	Local Time (formatted)
    * 
    * 
    * @returns currentTime without ISO UTC
    */
    getCurrentTime: () => {
      return new Date().toLocaleTimeString("en-US", { hour12: false });
    },

    /*
    * This API will return the system date and time from back-end in format 'MM/DD/YYYY HH:MMAM/PM' [Kamran A (3/19/25)]
    * 
    */
    getCurrentSystemDateTime: async function () {
      try{
        let APISource = APICom.GenerateSource();
        let response = await APICom.fetchData("main","TripActions/GetServerDBDateTime", "post", 
          {'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'mode': 'no-cors'}, {}, APISource
        );

        if(response && response.error.length === 0){
          return response.data;
        }
        else {
          return this.getCurrentDate() + " " + this.getCurrentTime();
        }
      } catch(err){console.log(err); return this.getCurrentDate() + " " + this.getCurrentTime();}
    },

    /*
    * This will return the military time from a given 12 hour time format string along with any system setting additions if provided [Kamran A (3/19/25)]
    * 
    */
    toMilitaryTime: function (timeString, addedSystemSettingMinutes = 0) {
      try{
        // Split the time string into time and period (AM/PM)
        let normalizedInput = timeString.replace(/\s+/g, ' ');
        let [time, period] = normalizedInput.split(" ");
        let [hours, minutes] = time.split(":").map(num => parseInt(num));
      
        // Convert to 24-hour time format
        if (period.toUpperCase() === "PM" && hours !== 12) {
          hours += 12; // Convert PM to 24-hour format
        }
        if (period.toUpperCase() === "AM" && hours === 12) {
          hours = 0; // Convert 12 AM to 00:00
        }
        let totalMinutes = hours * 60 + minutes + addedSystemSettingMinutes; //Adding system setting time in minutes to current time
        let newHours = Math.floor(totalMinutes/60) % 24;
        let newMinutes = totalMinutes % 60;
        // Format hours and minutes to two digits (e.g., 1:5 becomes 01:05)
        let militaryTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
        let timeSetting = `${String(newHours).padStart(2, "0")}:${String(newMinutes).padStart(2, "0")}`;
        return {military:militaryTime, timeWithSetting:timeSetting};
      }
      catch(err){console.log(err); return {military:timeString, timeWithSetting:timeString};}
    },

    /*
    * This will return correct date if user enters a date before 1900 [Kamran A (5/15/25)]
    * 
    */
    sanitizeDateInput: function (rawDate) {
      // Expect format YYYY-MM-DD
      const parts = rawDate.split('-');
      if (parts.length === 3) {
        let [year, month, day] = parts;
    
        // Check if year is invalid (e.g. starts with 0 or < 1900)
        if (parseInt(year, 10) < 1900 || year.length < 4) {
          const currentYear = new Date().getFullYear();
          // Replace with current year or guess from current decade
          year = currentYear.toString();
        }
    
        // Return corrected date string
        return `${year}-${month}-${day}`;
      }
    
      return rawDate; // fallback, return as-is if format is unexpected
    },

    /*
    * This will return the time with subtracted minutes from military time given. Made for automatic PU time calculation  [Kamran A (3/19/25)]
    * 
    */
    addsubtractMinutesFromMilitaryTime: function (time24, minutesToSubtract, minutesToAdd = 0) {
      try{
        // Split hours and minutes from the input time
        const [hours, minutes] = time24.split(':').map(Number);
        let totalMinutes = 0;
        if(minutesToAdd !== 0)
        {
          // Calculate total minutes and add
          totalMinutes = hours * 60 + minutes + minutesToAdd;
        }
        else
        {
          // Calculate total minutes and subtract
          totalMinutes = hours * 60 + minutes - minutesToSubtract;
        }
        
  
        // Handle cases where total minutes are negative
        if (totalMinutes < 0) {
          totalMinutes = (24 * 60 + totalMinutes) % (24 * 60); // Wraps around to previous day
        }
  
        // Convert back to hours and minutes
        const newHours = Math.floor(totalMinutes / 60) % 24;
        const newMinutes = totalMinutes % 60;
  
        // Pad hours and minutes with leading zeros if needed
        const paddedHours = String(newHours).padStart(2, '0');
        const paddedMinutes = String(newMinutes).padStart(2, '0');
  
        return `${paddedHours}:${paddedMinutes}`;
      }
      catch(err){
  
        console.log(err); 
        return time24;
      }
      
    },
  };

  export default DateTimeUtils;